export const  PLATFORMS_CONNECT_CODES = {
  Steam: 'Steam'
}
